import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["targetInput"]

  duplicateValue(event) {
    this.targetInputTarget.value = event.target.value
  }
}
